import { useEffect, useState } from "react"

// Tracks the current window width. Each consumer keeps its own resize listener
// (with cleanup) so a resize only re-renders the components that actually read
// the width, instead of every MainContext consumer.
export const useWindowWidth = (): number => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowWidth
}
